import Image1 from "../../assets/aadarsh.jpg";
import Image2 from "../../assets/priyanka.jpg";
import Image3 from "../../assets/smritee.jpg";

export const Data = [
  {
    id: 1,
    image: Image1,
    title: "Aadarsh Shiwakoti",
    description:
      "Reliable and hardworking, every project aspect was carefully executed, resulting in excellent outcomes."
  },
  {
    id: 2,
    image: Image3,
    title: "Smritee Mainali",
    description:
      "Working with Sudeshna was a pleasure; meeting all my expectations and providing exactly what I needed."
  },
  {
    id: 3,
    image: Image2,
    title: "Priyanka Upreti",
    description:
      "Sudeshna's friendly approach and keen eye for detail ensured seamless project execution."
  },

];